import React from 'react'
import { useSelector } from 'react-redux'
import $t from '../../../i18n'
import {
  filterAppointmentsPerMember,
  validAppointments,
} from '../../../utils/appointmentsUtils'
import AppointmentStatusCard from '../../common/AppointmentStatusCard'
import EmptyList from '../../common/EmptyList'
import Page from '../../common/Page'

import './FutureVisits.css'

const FutureVisits = () => {
  const appointments = useSelector(state => state.appointments.appointments)
  const selectedMember = useSelector(state => state.account?.selectedMember)

  const listOfAppointments = validAppointments(appointments)

  const futureVisitByMember = selectedMember?.id
    ? filterAppointmentsPerMember(listOfAppointments, selectedMember?.id)
    : listOfAppointments

  const sortAppointmentByDate = futureVisitByMember.sort((a, b) => {
    return new Date(a.schduled_time) - new Date(b.schduled_time)
  })

  const renderStatusCards = () => {
    return sortAppointmentByDate.length ? (
      sortAppointmentByDate?.map(eachAppointment => {
        const { id } = eachAppointment
        return <AppointmentStatusCard key={id} appointment={eachAppointment} />
      })
    ) : (
      <EmptyList
        title={$t('alerts.noItems', {
          category: $t('sideMenu.futureVisits').toLowerCase(),
        })}
      />
    )
  }

  return (
    <Page
      title={$t('sideMenu.futureVisits')}
      className="future-visit-page"
      displayManageFamily
    >
      {renderStatusCards()}
    </Page>
  )
}

export default FutureVisits
